module.exports = __webpack_public_path__ + "img/object-mark12.46ec3543.png";